import { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import staffingImage from "../../../assets/home/s5.webp";
import kpoImage from "../../../assets/home/s6.webp";
import botImage from "../../../assets/home/s7.webp";
import bpoImage from "../../../assets/home/s8.webp";
import "./globalCapDetailHero.css";

const heroImages = {
  "dedicated-staffing": staffingImage,
  kpo: kpoImage,
  "bot-lean-gcc": botImage,
  bpo: bpoImage,
};

export default function GlobalCapDetailHero({ data }) {
  const { slug } = useParams();
  const heroRef = useRef(null);
  const image = heroImages[slug] ?? staffingImage;

  const scrollToThirdSection = () => {
    const thirdSection =
      heroRef.current?.nextElementSibling?.nextElementSibling;

    if (!thirdSection) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    thirdSection.scrollIntoView({
      behavior: reduceMotion ? "auto" : "smooth",
      block: "start",
    });
  };

  return (
    <section className="gcdh-hero" ref={heroRef} key={slug}>
      <img
        src={image}
        alt=""
        className="gcdh-hero__image"
        width="1920"
        height="1080"
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
      <div className="gcdh-hero__overlay" aria-hidden="true" />
      <div className="gcdh-hero__glow" aria-hidden="true" />

      <div className="gcdh-hero__container">
        <div className="gcdh-hero__content">
          <div className="gcdh-hero__eyebrow">
            <span className="gcdh-hero__eyebrow-dot" aria-hidden="true" />
            <span>{data.eyebrow}</span>
          </div>

          <h1 className="gcdh-hero__title">{data.headline}</h1>

          <p className="gcdh-hero__description">{data.description}</p>

          <div className="gcdh-hero__actions">
            <Link
              to={data.primaryCta.href}
              className="gcdh-btn gcdh-btn--primary"
            >
              <span>{data.primaryCta.label}</span>
              <span className="gcdh-btn__icon" aria-hidden="true">
                ↗
              </span>
            </Link>

            <button
              type="button"
              className="gcdh-btn gcdh-btn--secondary"
              onClick={scrollToThirdSection}
            >
              <span>{data.secondaryCta.label}</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
